// Small bottom-right build-version indicator (autoviz-app parity —
// see /apps/autoviz-app/src/components/version-link.tsx). Reads the
// package.json version at build time via Vite's define plugin so
// there's no runtime import cost.

/** One anchor for the build stamp — the version text AND the tracking
 *  LED beside it. They were positioned independently, so moving the
 *  badge left the LED behind (2026-08-23 LUAT). Both read from here. */
export const BUILD_STAMP_ANCHOR = {
  right: 37,
  bottom: 2,
  // The LED's own offsets. It follows the badge when the badge moves,
  // but these two are tuned independently — the dot reads best slightly
  // left of and below the text's optical centre (2026-08-23).
  /** LED sits this far toward the screen edge from the badge's edge. */
  ledGapPx: 8,
  /** …and this much above the badge's baseline. */
  ledRisePx: 2,
} as const

const APP_VERSION = __APP_VERSION__
const APP_COMMIT = __APP_COMMIT__

export function VersionBadge() {
  return (
    <div
      data-testid="version-badge"
      style={{
        position: 'fixed',
        right: BUILD_STAMP_ANCHOR.right,
        bottom: BUILD_STAMP_ANCHOR.bottom,
        fontSize: 6,
        color: 'rgba(255, 255, 255, 0.65)',
        fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: 1000,
        textShadow: '0 0 3px rgba(0,0,0,0.6)',
        textAlign:'right'
      }}
    >
      v{APP_VERSION}+{APP_COMMIT}
    </div>
  )
}
